import React from 'react';
import { GameContainer, PauseButton, Background, Ground } from '../styles/StyledComponents';
import Character from './Character';
import Obstacle from './Obstacle';
import Enemy from './Enemy';
import Item from './Item';
import Projectile from './Projectile';
import ScoreBoard from './ScoreBoard';
import { Obstacle as ObstacleType, Enemy as EnemyType, Item as ItemType, Projectile as ProjectileType } from '../hooks/useGame';

interface GameScreenProps {
  score: number;
  highScore: number;
  coins: number;
  specialMeter: number;
  specialActive: boolean;
  isJumping: boolean;
  isSliding: boolean;
  obstacles: ObstacleType[];
  enemies: EnemyType[];
  items: ItemType[];
  projectiles: ProjectileType[];
  onPause: () => void;
  onJump: () => void;
  onSlide: () => void;
  onAttack: () => void;
  onUseSpecial: () => void;
}

const GameScreen: React.FC<GameScreenProps> = ({
  score,
  highScore,
  coins,
  specialMeter,
  specialActive,
  isJumping,
  isSliding,
  obstacles,
  enemies,
  items,
  projectiles,
  onPause,
  onJump,
  onSlide,
  onAttack,
  onUseSpecial
}) => {
  // 터치 혹은 클릭 이벤트에 따른 행동 통합 처리
  const handleInput = (e: React.TouchEvent | React.MouseEvent) => {
    let clientY: number;
    if ('touches' in e) {
      clientY = e.touches[0].clientY;
    } else {
      clientY = e.clientY;
    }
    const screenHeight = window.innerHeight;
    
    if (clientY < screenHeight / 3) {
      console.log("점프");
      onJump();
    } else if (clientY > (screenHeight * 2) / 3) {
      console.log("슬라이드");
      onSlide();
    } else {
      console.log("공격");
      onAttack();
    }
  };

  // 더블 클릭(혹은 더블 탭)으로 특수 능력 사용
  const handleDoubleTap = () => {
    if (specialMeter >= 100) {
      onUseSpecial();
    }
  };

  // 모바일 여부에 따라 이벤트 할당: 모바일이면 onTouchStart, 아니면 onClick
  const isMobile = 'ontouchstart' in window;

  return (
    <GameContainer 
      {...(isMobile 
          ? { onTouchStart: handleInput } 
          : { onClick: handleInput }
      )}
      onDoubleClick={handleDoubleTap}
    >
      <Background />
      <Ground />
      
      <ScoreBoard 
        score={score} 
        highScore={highScore} 
        coins={coins} 
        specialMeter={specialMeter} 
      />
      
      <Character isJumping={isJumping} isSliding={isSliding} />
      
      {obstacles.map(obstacle => (
        <Obstacle key={obstacle.id} obstacle={obstacle} />
      ))}
      
      {enemies.map(enemy => (
        <Enemy key={enemy.id} enemy={enemy} />
      ))}
      
      {items.map(item => (
        <Item key={item.id} item={item} />
      ))}
      
      {projectiles.map(projectile => (
        <Projectile key={projectile.id} projectile={projectile} />
      ))}
      
      <PauseButton onClick={onPause}>
        ⏸️
      </PauseButton>
      
      {specialActive && (
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(255, 159, 243, 0.2)',
          pointerEvents: 'none',
          zIndex: 5
        }} />
      )}
    </GameContainer>
  );
};

export default GameScreen;
